<template>
    <div class="content">
        <Topbar ref="topbar" />
        <div class="m-auto" style="padding-top: 30px; padding-bottom: 30px;width: 75%;">
            <Breadcrumb ref="breadcrumb" :title="'公告列表'" />
        </div>

        <div class="m-auto news" style="width: 72%;margin-bottom: 50px;">
            <div class="w-100% search-box flex justify-between align-center">
                <el-input v-model="detailsInfo.name" size="large" :clearable="false" class="search-input"
                    placeholder="请输入搜索内容" style="width: 90%;" @input="getDataList" />
                <i class="el-icon-search" color="#A40000" @click="getDataList"
                    style="font-size: 26px;color: #DCDFE6;display: flex;align-items: center;"></i>
            </div>

            <div class="flex menu-list">
                <div class="item font-weight font-20" v-for="(item, index) in homeMenuList" :key="index"
                    @click="handleMenu(item)">
                    <div :style="{ color: activeMenu.code === item.code ? '#A40000' : '#000' }">{{ item.name }}</div>
                    <i v-if="activeMenu.code === item.code" class="el-icon-caret-top icon"></i>
                </div>
            </div>

            <div v-loading="loading" element-loading-text="数据加载中..."
                element-loading-background="rgba(255, 255, 255, 0.8)" style="min-height: 300px;">
                <ul v-if="newsList.length > 0" class="size-18 ul-disc">
                    <li class="right-li li-before  li-line-height  font-18 flex align-center justify-between"
                        v-for="(item, index) in newsList" :key="index" @click="toDetails(item)">
                        <div class="flex-1 text-omit-1 text-width">{{ item.name }}
                        </div>
                        <div class="font-14" style="margin-left: 70px;">{{ item.createTime | fmDate }}</div>
                    </li>
                </ul>
                <el-empty v-else :image-size="200"></el-empty>
            </div>
            <div class="flex" style="justify-content: end;margin-top: 30px;">
                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="detailsInfo.pageNo" :page-sizes="[15, 30, 45, 60]" :page-size="detailsInfo.pageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="dataTotal">
                </el-pagination>
            </div>
        </div>
        <Footer />
    </div>
</template>
<script>
import Breadcrumb from "@/components/Breadcrumb/index.vue";
import { getList } from '@/api/home/cmsIndex.js'
export default {
    name: "NewsList",
    components: {
        Breadcrumb,
        // Video 组件假设已全局注册，如未注册需在此引入
    },
    data() {
        return {
            homeMenuList: [
                { name: '全部', code: 'SYWZ', activeName: '通知公告', value: '' },
                { name: '考试公告', code: 'KSGG', activeName: '考试公告', value: 'category_cms_exam' },
                { name: '成绩公示', code: 'CJGS', activeName: '成绩公示', value: 'category_cms_score' },
            ],
            activeMenu: { name: '全部', code: 'SYWZ', activeName: '通知公告', value: '' },
            detailsInfo: { pageNo: 1, pageSize: 15, category: '', name: '' },
            newsList: [],
            dataTotal: 0,
            loading: false,
        }
    },
    created() {
        this.activeMenu = this.$route.query
        this.detailsInfo.category = this.activeMenu.value
        console.log(this.$route.query, 'this.$route.query');
        this.getDataList()
    },
    methods: {
        // menu 切换
        handleMenu(item) {
            this.activeMenu = item;
            this.detailsInfo.category = item.value;
            this.detailsInfo.pageNo = 1;
            this.getDataList()
        },
        async getDataList() {
            this.loading = true;
            try {
                const data = await getList(this.detailsInfo);
                this.newsList = data.list
                this.dataTotal = data.total
            } finally {
                this.loading = false;
            }

        },
        handleCurrentChange(val) {
            this.detailsInfo.pageNo = val
            this.getDataList()
        },
        handleSizeChange(val) {
            this.detailsInfo.pageSize = val
            this.getDataList()
        },
        toDetails(item) {
            const routeUrl = this.$router.resolve({
                path: '/details',
                query: { id: item.id }
            });
            window.open(routeUrl.href);
        },
    }
}
</script>

<style lang="scss" scoped>
.content {
    .news {
        max-width: 1400px;
    }
}

.search-box {
    background: #FFFFFF;
    // box-shadow: 0px 0px 2px 0px #C5C5C5;
    border-radius: 10px;
    border: 2px solid #DCDFE6;
    padding: 5px 20px;

    .search-input {
        border: none !important;
    }
}

::v-deep .el-input__inner {
    border: none !important;
    font-size: 18px;
    font-weight: 500;
}

::v-deep .el-loading-spinner .path {
    stroke: #A40000 !important;
}

::v-deep .el-loading-text {
    color: #A40000;
}

.menu-list {
    width: 100%;
    justify-content: space-around;
    padding: 0 20px;
    border-bottom: 1px solid #A40000;
    margin: 40px 0 40px;

    .item {
        position: relative;
        padding-bottom: 20px;
        cursor: pointer;
        white-space: nowrap;
    }

    .icon {
        position: absolute;
        bottom: -9px;
        left: 50%;
        transform: translateX(-50%);
        color: #A40000;
        font-size: 26px;
    }
}

.ul-disc {
    padding-left: 0;
    list-style: none;
    color: #000000;
    cursor: pointer;
    line-height: 48px;
    margin-bottom: 60px;
}

/* li 圆点 */
.ul-disc li {
    position: relative;
    padding-left: 15px;
}

.right-li {
    padding-bottom: 0 !important;
}

.li-before:before {
    content: "";
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: #A40000;
    display: block;
    margin-right: 5px;
    /* vertical-align: middle; */
    // margin-top: -3px;
    position: absolute;
    left: 0;
    top: 50%;
}

.li-before:hover::before {
    background: #A40000;
}

.li-before:hover {
    color: #A40000;
}

li::marker {
    color: #A40000 !important;
}

.text-width {
    margin-right: 5ex;
}

::v-deep .el-pager li.active {
    background: #A40000 !important;
    color: #FFFFFF !important;
}

::v-deep .el-pager li:hover {
    background: #A40000 !important;
    color: #FFFFFF !important;
}

/* 平板端适配 */
@media screen and (max-width: 1024px) {
    .content {
        .m-auto {
            width: 90% !important;
        }

        .news {
            width: 90% !important;
        }
    }

    .menu-list {
        padding: 0 10px;
        margin: 30px 0 30px;

        .item {
            font-size: 18px;
            padding-bottom: 16px;
        }

        .icon {
            font-size: 22px;
            bottom: -7px;
        }
    }

    .ul-disc {
        font-size: 16px;
        line-height: 40px;
        margin-bottom: 20px;

        li {
            padding-left: 12px;

            .font-18 {
                font-size: 16px !important;
            }

            .font-14 {
                font-size: 12px !important;
                margin-left: 30px !important;
            }
        }

        .text-width {
            margin-right: 2%;
        }
    }
}

/* 手机端适配 */
@media screen and (max-width: 768px) {
    .content {
        .m-auto {
            width: 94% !important;
            padding-top: 20px;
            padding-bottom: 20px;
        }

        .news {
            width: 94% !important;
            margin-bottom: 30px;
        }
    }

    .search-box {
        padding: 5px 15px;

        ::v-deep .el-input__inner {
            font-size: 15px;
        }
    }

    .menu-list {
        padding: 0;
        margin: 24px 0 24px;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
        justify-content: center;
        gap: 20px;

        &::-webkit-scrollbar {
            display: none;
        }

        .item {
            font-size: 16px;
            padding-bottom: 14px;
            flex-shrink: 0;
        }

        .icon {
            font-size: 20px;
            bottom: -7px;
        }
    }

    .ul-disc {
        font-size: 14px;
        line-height: 36px;
        margin-bottom: 0;

        li {
            padding-left: 10px;
            align-items: flex-start !important;

            .text-width {
                margin-right: 20px;
            }

            .font-18 {
                font-size: 14px !important;
            }

            .font-14 {
                font-size: 12px !important;
                margin-left: 0 !important;
                color: #999;
            }
        }
    }

    /* 分页居中显示 */
    .news .flex:last-child {
        justify-content: center !important;
    }

    ::v-deep .el-pagination {

        .el-pagination__total,
        .el-pagination__sizes {
            display: none;
        }
    }
}
</style>